export default function selectTopLeftObject(fabricCanvas) {
  const objects = fabricCanvas.getObjects();
  let minDistanceSquared = 10000000000;
  let topLeftmostObjectIndex = -1;
  if (objects){
    for (let i=0; i<objects.length; i++){
      const obj = objects[i];
      const distanceSquaredFromTopLeft = obj.left * obj.left + obj.top * obj.top;
      if (distanceSquaredFromTopLeft < minDistanceSquared){
        topLeftmostObjectIndex = i;
        minDistanceSquared = distanceSquaredFromTopLeft;
      }
    }
  }
  // gotta use indices here :-(
  // https://stackoverflow.com/questions/20096949/how-to-select-fabric-js-object-programmatically
  if (topLeftmostObjectIndex >= 0){
    fabricCanvas.setActiveObject(fabricCanvas.item(topLeftmostObjectIndex));
    const active = fabricCanvas.getActiveObject();

    if (active.type === 'IText'){
      const endCharacterPosition = active.text ? active.text.length : 0;
      active.setSelectionStart(endCharacterPosition);
      active.setSelectionEnd(endCharacterPosition);
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/selectTopLeftObject.js